(function() {
  if (window.HCHeaderInit) return;
  window.HCHeaderInit = true;

  const header = document.getElementById('hc-header');
  if (!header) return;

  const overlay = document.querySelector('[data-hc-overlay]');
  const triggers = document.querySelectorAll('[data-panel-trigger]');
  const submenuPanels = header.querySelectorAll('.hc-panel--submenu');
  const mlevelsContainer = header.querySelector('.hc-mlevels');
  const mlevelOpens = header.querySelectorAll('[data-mlevel-open]');
  const mlevelBacks = header.querySelectorAll('[data-mlevel-back]');
  const cartContent = header.querySelector('[data-cart-content]');
  const sectionId = header.dataset.sectionId;

  let currentMenuKey = null;
  let hoverCloseTimer = null;

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

function setHeaderHeight() {
    // Dois rAF garantem que o navegador completou o layout/paint
    // antes de medirmos a altura do painel
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const state = header.dataset.state;
        if (state === 'default') {
          header.style.removeProperty('--hc-expanded-height');
          return;
        }

        let activePanel = null;
        if (state === 'menu') {
          activePanel = isMobile()
            ? header.querySelector('.hc-panel--mobile-menu')
            : header.querySelector('.hc-panel--submenu.is-active');
        } else {
          activePanel = header.querySelector(`.hc-panel[data-panel="${state}"]`);
        }

        if (activePanel) {
          // Mede o conteúdo INTERNO (mais confiável que scrollHeight do painel)
          const inner = activePanel.querySelector('.hc-panel-content') || activePanel;
          const contentHeight = inner.scrollHeight;
          header.style.setProperty('--hc-expanded-height', `${64 + contentHeight}px`);
        }
      });
    });
  }

  function updateOverlay() {
    if (!overlay) return;
    overlay.classList.toggle('is-active', header.dataset.state !== 'default');
  }

  function syncTriggersState() {
    triggers.forEach(t => {
      const panel = t.dataset.panelTrigger;
      const key = t.dataset.menuKey;
      const isActive = (header.dataset.state === panel) &&
                       (key === undefined || key === currentMenuKey);
      t.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
  }

  function openPanel(panel, menuKey) {
    header.dataset.state = panel;
    if (panel === 'menu' && menuKey !== 'mobile' && !isMobile()) {
      submenuPanels.forEach(p => p.classList.toggle('is-active', p.dataset.menuKey === menuKey));
    }
    currentMenuKey = menuKey;
    setHeaderHeight();
    updateOverlay();
    syncTriggersState();
  }

  function closePanel() {
    header.dataset.state = 'default';
    submenuPanels.forEach(p => p.classList.remove('is-active'));
    currentMenuKey = null;
    header.style.removeProperty('--hc-expanded-height');
    updateOverlay();
    syncTriggersState();
  }

  triggers.forEach(t => {
    const panel = t.dataset.panelTrigger;
    const key = t.dataset.menuKey;

    if (!isMobile() && panel === 'menu' && key !== 'mobile' && t.closest('#hc-header')) {
      t.addEventListener('mouseenter', () => {
        clearTimeout(hoverCloseTimer);
        openPanel('menu', key);
      });
    }

    t.addEventListener('click', (e) => {
      if (t.tagName === 'A' && !isMobile() && !t.dataset.menuKey) return;
      e.preventDefault();
      e.stopPropagation();
      const isActive = (header.dataset.state === panel && currentMenuKey === key);
      isActive ? closePanel() : openPanel(panel, key);
    });
  });

  header.addEventListener('mouseleave', () => { if (!isMobile()) hoverCloseTimer = setTimeout(closePanel, 300); });
  header.addEventListener('mouseenter', () => clearTimeout(hoverCloseTimer));

  if (overlay) {
    overlay.addEventListener('click', closePanel);
  }

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && header.dataset.state !== 'default') closePanel();
  });

  // Mobile Levels
  mlevelOpens.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const targetId = btn.dataset.mlevelOpen;
      header.querySelectorAll('.hc-mlevel').forEach(l => l.classList.remove('is-active'));
      const targetPanel = header.querySelector(`[data-mlevel-id="${targetId}"]`);
      if (targetPanel) {
        targetPanel.classList.add('is-active');
        mlevelsContainer.dataset.activeLevel = targetId.split('-')[0];
      }
      setHeaderHeight();
    });
  });

  mlevelBacks.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const backId = btn.dataset.mlevelBack;
      header.querySelectorAll('.hc-mlevel').forEach(l => l.classList.remove('is-active'));
      if (backId === "0") {
        mlevelsContainer.dataset.activeLevel = "0";
      } else {
        const prev = header.querySelector(`[data-mlevel-id="${backId}"]`);
        if (prev) prev.classList.add('is-active');
        mlevelsContainer.dataset.activeLevel = backId.split('-')[0];
      }
      setHeaderHeight();
    });
  });

  // ============ CARRINHO ============

  // Atualiza badge de contagem
async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js', { cache: 'no-store' });
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        const oldCount = parseInt(el.textContent, 10) || 0;
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;

        // Pulsa se aumentou
        if (cart.item_count > oldCount) {
          el.classList.remove('is-pulsing');
          // Force reflow pra reiniciar animação
          void el.offsetWidth;
          el.classList.add('is-pulsing');
        }
      });
    } catch (err) {
      console.error('Cart count refresh failed:', err);
    }
  }

  // Re-renderiza HTML completo do mini-cart via Section Rendering API
  async function refreshCartContent() {
    if (!cartContent || !sectionId) return;
    try {
      const res = await fetch(`${window.location.pathname}?sections=${sectionId}`, { cache: 'no-store' });
      const data = await res.json();
      const html = data[sectionId];
      if (!html) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.querySelector('[data-cart-content]');
      if (newContent) {
        cartContent.innerHTML = newContent.innerHTML;
        attachCartEvents();
        if (header.dataset.state === 'cart') {
          setHeaderHeight();
        }
      }
    } catch (err) {
      console.error('Cart content refresh failed:', err);
    }
  }

  // Refresh completo (badge + conteúdo)
  async function refreshCart() {
    await Promise.all([refreshCartCount(), refreshCartContent()]);
  }

  // Anexa eventos aos botões do mini-cart (qty +/−, remove)
  function attachCartEvents() {
    if (!cartContent) return;

    cartContent.querySelectorAll('[data-cart-qty-change]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const lineKey = btn.dataset.lineKey;
        const direction = parseInt(btn.dataset.direction, 10);
        const lineEl = btn.closest('[data-cart-line]');
        const numEl = lineEl?.querySelector('.hc-cart-qty-num');
        const currentQty = parseInt(numEl?.textContent || '1', 10);
        const newQty = Math.max(0, currentQty + direction);

        btn.disabled = true;
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: newQty })
          });
          await refreshCart();
        } catch (err) {
          console.error('Quantity change failed:', err);
          btn.disabled = false;
        }
      });
    });

    cartContent.querySelectorAll('[data-cart-remove]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const lineKey = btn.dataset.lineKey;

        btn.disabled = true;
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: 0 })
          });
          await refreshCart();
        } catch (err) {
          console.error('Remove failed:', err);
          btn.disabled = false;
        }
      });
    });
  }

  // Refresh inicial
// Refresh inicial
  refreshCartCount();
  attachCartEvents();

  // ============ OBSERVA MUDANÇAS NO CARRINHO ============
  // Quando o HTML do mini-cart muda (adicionar/remover/qtd),
  // re-mede a altura do painel automaticamente
  if (cartContent) {
    const cartObserver = new MutationObserver(() => {
      if (header.dataset.state === 'cart') {
        setHeaderHeight();
      }
    });
    cartObserver.observe(cartContent, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

// 1. Pub/Sub do Dawn — abre painel ANTES, depois atualiza
  if (window.PUB_SUB_EVENTS && window.subscribe) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, async () => {
      openPanel('cart', null);
      await refreshCart();
      setHeaderHeight();
    });
  }

// 2. Custom event das nossas sections — abre painel ANTES, depois atualiza
  document.addEventListener('cart:added', async () => {
    openPanel('cart', null);       // Abre primeiro (UX rápida)
    await refreshCart();            // Atualiza conteúdo
    setHeaderHeight();              // Re-mede altura com novo conteúdo
  });

  // 3. Intercepta TODAS as chamadas pro carrinho (fetch)
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
      const url = args[0];
      const urlString = typeof url === 'string' ? url : (url?.url || '');
if (
        urlString.includes('/cart/add') ||
        urlString.includes('/cart/change') ||
        urlString.includes('/cart/update') ||
        urlString.includes('/cart/clear')
      ) {
        if (!urlString.includes('?sections=')) {
          setTimeout(() => {
            refreshCart();
            // Só abre o painel ao ADICIONAR (não em change/remove)
            if (urlString.includes('/cart/add')) {
              openPanel('cart', null);
            }
          }, 150);
        }
      }
      return response;
    });
  };

  // 4. Intercepta XHR
  const originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this.addEventListener('load', () => {
if (typeof url === 'string' && (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      )) {
        setTimeout(() => {
          refreshCart();
          if (url.includes('/cart/add')) {
            openPanel('cart', null);
          }
        }, 150);
      }
    });
    return originalXHROpen.call(this, method, url, ...rest);
  };

  // 5. Atualiza ao voltar à aba
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      refreshCart();
    }
  });
  // ============ LIVE SEARCH ============
  const searchForm = header.querySelector('[data-search-form]');
  const searchInput = header.querySelector('[data-search-input]');
  const searchResults = header.querySelector('[data-search-results]');
  const searchResultsContent = header.querySelector('[data-search-results-content]');

  if (searchForm && searchInput && searchResults && searchResultsContent) {
    let searchDebounceTimer = null;
    let lastQuery = '';
    let activeFocusIndex = -1;

    // Texto exibido quando o produto tem preço 0 (mesma regra da página de produto)
    const CONSULT_LABEL = 'Sob consulta';

    function escapeHtml(str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function highlightMatch(text, query) {
      if (!text || !query) return escapeHtml(text);
      const safeText = escapeHtml(text);
      const safeQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`(${safeQuery})`, 'gi');
      return safeText.replace(regex, '<span class="hc-search-highlight">$1</span>');
    }

    function formatMoney(cents) {
      const value = (parseInt(cents, 10) || 0) / 100;
      return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'BRL'
      });
    }

    function renderSpinner(loading) {
      searchForm.classList.toggle('is-loading', loading);
    }

    function renderEmpty(query) {
      searchResultsContent.innerHTML = `
        <div class="hc-search-empty">
          Nada encontrado para "<strong>${escapeHtml(query)}</strong>"
        </div>
      `;
      searchResults.hidden = false;
      setHeaderHeight();
    }

    function renderResults(data, query) {
      const products = data.resources?.results?.products || [];
      const collections = data.resources?.results?.collections || [];
      const queries = data.resources?.results?.queries || [];
      const pages = data.resources?.results?.pages || [];
      const articles = data.resources?.results?.articles || [];

      const totalResults = products.length + collections.length + queries.length + pages.length + articles.length;

      if (totalResults === 0) {
        renderEmpty(query);
        return;
      }

      let html = '';

      // PRODUTOS
      if (products.length) {
        html += `<div class="hc-search-section">
          <p class="hc-search-section-title">Produtos</p>
          <div class="hc-search-products">`;

        products.forEach(p => {
          const imgUrl = p.featured_image?.url || p.image || '';
          const img = imgUrl
            ? `<img class="hc-search-product-img" src="${escapeHtml(imgUrl)}" alt="${escapeHtml(p.title)}" loading="lazy">`
            : `<div class="hc-search-product-img-ph"></div>`;

          // Produto sob consulta = preço 0.
          // A API devolve o preço como texto ("0.00"), que é truthy em JS —
          // por isso a comparação precisa ser numérica.
          const priceValue = parseFloat(p.price);
          const isConsult = !priceValue || priceValue === 0;

          const price = isConsult
            ? `<span class="hc-search-product-consult">${CONSULT_LABEL}</span>`
            : formatMoney(p.price * 100);

          const compareAt = (!isConsult && p.compare_at_price && parseFloat(p.compare_at_price) > priceValue)
            ? `<span class="hc-search-product-price-compare">${formatMoney(p.compare_at_price * 100)}</span>`
            : '';

          html += `
            <a href="${escapeHtml(p.url)}" class="hc-search-product" data-search-result>
              ${img}
              <div class="hc-search-product-info">
                <p class="hc-search-product-title">${highlightMatch(p.title, query)}</p>
                ${price ? `<p class="hc-search-product-price">${price}${compareAt}</p>` : ''}
              </div>
            </a>
          `;
        });

        html += `</div></div>`;
      }

      // COLEÇÕES
      if (collections.length) {
        html += `<div class="hc-search-section">
          <p class="hc-search-section-title">Coleções</p>
          <ul class="hc-search-list">`;
        collections.forEach(c => {
          html += `<li><a href="${escapeHtml(c.url)}" class="hc-search-link" data-search-result>${highlightMatch(c.title, query)}</a></li>`;
        });
        html += `</ul></div>`;
      }

      // SUGESTÕES DE BUSCA
      if (queries.length) {
        html += `<div class="hc-search-section">
          <p class="hc-search-section-title">Sugestões</p>
          <ul class="hc-search-list">`;
        queries.forEach(q => {
          const url = `/search?q=${encodeURIComponent(q.text)}`;
          html += `<li><a href="${escapeHtml(url)}" class="hc-search-link" data-search-result>${highlightMatch(q.text, query)}</a></li>`;
        });
        html += `</ul></div>`;
      }

      // PÁGINAS
      if (pages.length) {
        html += `<div class="hc-search-section">
          <p class="hc-search-section-title">Páginas</p>
          <ul class="hc-search-list">`;
        pages.forEach(p => {
          html += `<li><a href="${escapeHtml(p.url)}" class="hc-search-link" data-search-result>${highlightMatch(p.title, query)}</a></li>`;
        });
        html += `</ul></div>`;
      }

      // ARTIGOS
      if (articles.length) {
        html += `<div class="hc-search-section">
          <p class="hc-search-section-title">Artigos</p>
          <ul class="hc-search-list">`;
        articles.forEach(a => {
          html += `<li><a href="${escapeHtml(a.url)}" class="hc-search-link" data-search-result>${highlightMatch(a.title, query)}</a></li>`;
        });
        html += `</ul></div>`;
      }

      // VER TODOS
      const viewAllUrl = `/search?q=${encodeURIComponent(query)}`;
      html += `<a href="${escapeHtml(viewAllUrl)}" class="hc-search-viewall" data-search-result>Ver todos os resultados para "${escapeHtml(query)}"</a>`;

      searchResultsContent.innerHTML = html;
      searchResults.hidden = false;
      activeFocusIndex = -1;
      setHeaderHeight();
    }

    async function performSearch(query) {
      if (!query || query.length < 2) {
        searchResults.hidden = true;
        searchResultsContent.innerHTML = '';
        renderSpinner(false);
        setHeaderHeight();
        return;
      }

      renderSpinner(true);

      try {
        const params = new URLSearchParams({
          'q': query,
          'resources[type]': 'product,collection,query,page,article',
          'resources[limit]': '6',
          'resources[options][unavailable_products]': 'last',
          'resources[options][fields]': 'title,product_type,variants.title,vendor'
        });

        const res = await fetch(`/search/suggest.json?${params.toString()}`, {
          headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) throw new Error('Search failed');
        const data = await res.json();
        renderResults(data, query);
      } catch (err) {
        console.error('Search error:', err);
        renderEmpty(query);
      } finally {
        renderSpinner(false);
      }
    }

    // Debounce do input
    searchInput.addEventListener('input', () => {
      const query = searchInput.value.trim();
      if (query === lastQuery) return;
      lastQuery = query;

      clearTimeout(searchDebounceTimer);

      if (!query) {
        searchResults.hidden = true;
        searchResultsContent.innerHTML = '';
        renderSpinner(false);
        setHeaderHeight();
        return;
      }

      searchDebounceTimer = setTimeout(() => {
        performSearch(query);
      }, 300);
    });

    // Limpa quando o painel fecha
    function clearSearch() {
      searchInput.value = '';
      lastQuery = '';
      searchResults.hidden = true;
      searchResultsContent.innerHTML = '';
      renderSpinner(false);
      activeFocusIndex = -1;
    }

    // Quando muda de painel, limpa
    const searchTrigger = header.querySelector('[data-panel-trigger="search"]');
    if (searchTrigger) {
      searchTrigger.addEventListener('click', () => {
        // Pequeno delay pra esperar o painel abrir
        setTimeout(() => {
          if (header.dataset.state === 'search') {
            searchInput.focus();
          } else {
            clearSearch();
          }
        }, 350);
      });
    }

    // Limpa também quando fecha pelo overlay/ESC
    if (overlay) {
      overlay.addEventListener('click', clearSearch);
    }
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && header.dataset.state === 'search') {
        clearSearch();
      }
    });

    // Navegação com teclado (setas + enter)
    function getResultElements() {
      return Array.from(searchResultsContent.querySelectorAll('[data-search-result]'));
    }

    function setActiveFocus(index) {
      const items = getResultElements();
      items.forEach(el => el.classList.remove('is-focused'));
      if (index >= 0 && index < items.length) {
        items[index].classList.add('is-focused');
        items[index].scrollIntoView({ block: 'nearest' });
        activeFocusIndex = index;
      } else {
        activeFocusIndex = -1;
      }
    }

    searchInput.addEventListener('keydown', e => {
      const items = getResultElements();

      if (e.key === 'ArrowDown') {
        if (!items.length) return;
        e.preventDefault();
        const next = activeFocusIndex < items.length - 1 ? activeFocusIndex + 1 : 0;
        setActiveFocus(next);
      } else if (e.key === 'ArrowUp') {
        if (!items.length) return;
        e.preventDefault();
        const prev = activeFocusIndex > 0 ? activeFocusIndex - 1 : items.length - 1;
        setActiveFocus(prev);
      } else if (e.key === 'Enter') {
        if (activeFocusIndex >= 0 && items[activeFocusIndex]) {
          e.preventDefault();
          items[activeFocusIndex].click();
        }
        // Se não tem item focado, deixa o submit do form acontecer normal
      }
    });

    // Submit do form vai pra /search?q= (comportamento padrão, sem preventDefault)
  }
})();
